import { Text } from "ui/Typography"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { Flex } from "antd"
import googleIcon from "assets/imagesV2/social/google.svg"
import facebookIcon from "assets/imagesV2/social/facebook-squared.svg"
import appleIcon from "assets/imagesV2/social/apple-black.svg"
import { spacings } from "themes/variables"

const backendProviderKeys = {
  google_oauth2: { label: "Google", icon: googleIcon },
  facebook: { label: "Facebook", icon: facebookIcon },
  apple: { label: "Apple", icon: appleIcon }
}

const LinkedWithAccount = () => {
  const { t } = useTranslation()
  const { connected_oauth_providers } = useSelector((state) => state.user)

  return (
    <Flex vertical gap={spacings.S}>
      {connected_oauth_providers?.map((provider) => (
        <Flex key={provider} gap={spacings.XS} align="center">
          <img src={backendProviderKeys[provider]?.icon} alt={backendProviderKeys[provider]?.label} width={24} height={24} />
          <Text fw={500}>{t("client.profile.tabs.profile.linked_with", { provider: backendProviderKeys[provider]?.label })}</Text>
        </Flex>
      ))}
    </Flex>
  )
}

export default LinkedWithAccount
